import React, {createRef, useContext} from "react";
import {Fade} from "react-reveal";
import "./ExperienceCard.scss";
import StyleContext from "../../contexts/StyleContext";

export default function ExperienceCard({experience}) {
  const imgRef = createRef();

  const GetDescBullets = ({descBullets}) => {
    return descBullets
      ? descBullets.map((item, i) => (
          <li key={i} className="experience-text-desc">
            {item}
          </li>
        ))
      : null;
  };
  const {isDark} = useContext(StyleContext);

  if (!experience.companylogo)
    console.error(`Image of ${experience.company} is missing in experience section`);
  return (
    <div>
      <Fade duration={1000}>
        <div className="experience-card">
          {experience.companylogo && (
            <div className="experience-card-left">
              <img
                crossOrigin={"anonymous"}
                ref={imgRef}
                className={
                  isDark
                    ? "experience-roundedimg-dark"
                    : "experience-roundedimg"
                }
                src={experience.companylogo}
                alt={experience.company}
              />
            </div>
          )}
          <div className="experience-card-right">
            <h5 className="experience-text-experience">{experience.company}</h5>

            <div className="experience-text-details">
              <h5
                className={
                  isDark
                    ? "dark-mode experience-text-role"
                    : "experience-text-role"
                }
              >
                {experience.role}
              </h5>
              <p
                className={`${
                  isDark ? "dark-mode" : ""
                } experience-text-duration`}
              >
                {experience.date}
              </p>
              <p className="experience-text-desc">{experience.desc}</p>
              <div className="experience-text-bullets">
                <ul>
                  <GetDescBullets descBullets={experience.descBullets} />
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Fade>
      <Fade duration={1000}>
        <div className="experience-card-border"></div>
      </Fade>
    </div>
  );
}
